const television = [
    {
        alias: "whatreyouat",
        navigation: [
            {
                link: "/television/whatreyouat",
                title: "Latest",
                type: "internal",
            },
        ],
    },
    {
        alias: "anyonesgame",
        navigation: [
            {
                link: "https://www.cbc.ca/1.5723785",
                title: "Watch Full Episodes",
                type: "external",
            },
        ],
    },
    {
        alias: "raceagainstthetide",
        navigation: [
            {
                link: "https://www.cbc.ca/1.5999768",
                title: "Watch Full Episodes",
                type: "external",
            },
        ],
    },
];

export default television;
